<template>
  <div class="noticeable-top-banner"></div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import { destroyTopBanner, renderTopBanner } from '.';

onMounted(async () => {
  renderTopBanner('.noticeable-top-banner');
});
onUnmounted(() => {
  destroyTopBanner();
});
</script>
